// extracted by mini-css-extract-plugin
export var gif = "_ku-0";